export class LayoutFormatHelper {
    static _a4Format = "A4";
    static _a5Format = "A5";
    static _horizontalOrientation = "Horizontal";
    static _verticalOrientation = "Vertical";
    static _a4Width = 2100;
    static _a4Height = 2970;
    static _a5Width = 1480;
    static _a5Height = 2100;

    static createLayoutObject(layoutProps) {
        let id = 0;
        let name = "";
        let format = this._a4Format;
        let orientation = this._verticalOrientation;
        if (null !== layoutProps && undefined !== layoutProps) {
            id = layoutProps.id;
            name = layoutProps.name;
            format = this.getFormatFromDimentions(layoutProps.width, layoutProps.height);
            orientation = this.getOrientationFromDimentions(layoutProps.width, layoutProps.height);
        }

        return {
            id: id,
            modified: false,
            name: name,
            format: format,
            orientation: orientation
        };
    }

    static getFormatFromDimentions(width, height) {
        if ((this._a4Width === width && this._a4Height === height) || (this._a4Width === height && this._a4Height === width)) {
            return this._a4Format;
        }

        if ((this._a5Width === width && this._a5Height === height) || (this._a5Width === height && this._a5Height === width)) {
            return this._a5Format;
        }

        return "";
    }

    static getOrientationFromDimentions(width, height) {
        return width > height ? this._horizontalOrientation : this._verticalOrientation;
    }

    static getLayoutPropertiesObject(name, format, orientation) {
        let width = 0;
        let height = 0;

        // Set as vertical orientation
        if (this._a4Format === format) {
            width = this._a4Width;
            height = this._a4Height;
        }
        else if (this._a5Format === format) {
            width = this._a5Width;
            height = this._a5Height;
        }

        if (this._horizontalOrientation === orientation) {
            const temp = width;
            width = height;
            height = temp;
        }

        return {
            name: name,
            width: width,
            height: height
        };
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/helpers/LayoutFormatHelper.js